import { ref } from "vue";

const notifications = ref([]);

export function useNotification() {
    const showNotification = (message, type = "info", duration = 3000) => {
        const id = Date.now();
        notifications.value.push({ id, message, type, duration });

        setTimeout(() => {
            notifications.value = notifications.value.filter(
                (n) => n.id !== id
            );
        }, duration);
    };

    return { notifications, showNotification };
}
